/**
 * ExtensionPromo.tsx — since landing v9 the standalone section is gone; the
 * extension lives inside MultimodalInputs as the lead input card. What remains
 * here is CWS_URL, the single source of truth for the Chrome Web Store listing
 * (Hero and MultimodalInputs both link to it).
 */

// Live on the Chrome Web Store since 2026-08-17 (v0.3.1).
export const CWS_URL =
  'https://chromewebstore.google.com/detail/piccard-offline-dictionar/jikkgpioaahahbfemibfihbgohlabaoj'
